<template>
    <div class="wrapper">
        <div style="display:flex" class="col-sm-12 col-md-9" v-if="data">
            <img class="background" :src="assignmentImage">
            <div style="height:100%;" class="col-sm-9 course-description">
                <div v-if="$route.name !== 'campus-dashboard'">
                    <h4 v-if="$route.name != 'videoPlayer'">
                        <router-link :to="{
                    name: 'videoPlayer',
                    params: { courseId: data.courseId, instanceId: data.instanceId,
                        videoId : data.videoId }, query: { week: data.week, tab: 'assignment' } }">
                            Week {{data.week}}</router-link>, {{data.name}}
                    </h4>
                    <h4 v-else>
                        Week {{data.week}}, {{data.name}}
                    </h4>
                </div>
                <div v-else>
                    <h4>{{data.name}}</h4>
                </div>
                <div v-html="data.description"></div>
            </div>
            <div class="col-sm-12 col-md-3">
                <img class="assignment-image" v-if="data.image" @click="showLightBox=true" :src="assignmentImage">
            </div>
        </div>
        <div class="col-sm-12 col-md-3 assignment-sidebar">
            <div v-if="$route.name !== 'campus-dashboard'">
                <h4>Due Date:<i class="clippie fa fa-info-circle" v-tooltip="'If the due date has passed, you may not get a mark or feedback unless you contact your supervisor.'"></i></h4>
                <p class="due-date">{{data.dueDate | shortDate}}</p>
                <countdown v-if="new Date(data.dueDate) > new Date()" :date="data.dueDate"></countdown>
            </div>
            <h4>Assignment Files:<i class="clippie fa fa-info-circle" v-tooltip="'Find files here required or related to your assignment.'"></i></h4>
            <ul v-if="data.files || (data.watermarkedFiles && data.watermarkedFiles.length > 0)" class="student-submitted-files">
                <li v-for="file in data.files">
                    <!-- <a :href="file" target="_blank">{{file | filenameFromUrl}}</a> -->
                    <a @click.prevent="downloadFile(file, data.id)">{{file | filenameFromUrl}}</a>
                </li>
                <li v-for="file in data.watermarkedFiles">
                    <a href="#" @click.prevent="downloadFile(file, data.id)" target="_blank">{{file | filenameFromUrl}}</a>
                </li>
            </ul>
            <span v-else class="no-files">No files for this assignment</span>
            <div v-if="showDAMSubmission" class="modal-overlay final-project-submission-modal">
                <i class="close-modal fa fa-times" @click="showDAMSubmission = false"></i>
                <dam-submission :type="'finalAssignment'" :assignment="data"></dam-submission>
            </div>
            <div v-if="$route.name !== 'campus-dashboard'">
                <div v-if="data.isFinalProject === true" class="final-assignment-submission">
                    <h4>Submissions:<i class="clippie fa fa-info-circle" v-tooltip="'You can optionally add a submission to the gallery'"></i></h4>
                    <button @click.prevent="showDAMSubmission = true" class="btn btn-success" :class="{'resubmit': data.submissions && data.submissions.length > 0}">
                        <span v-if="data.submissions && data.submissions.length > 0">Resubmit Final Project</span>
                        <span v-else>Submit Final Project</span>
                    </button>

                    <p class="resubmission-instructions">Please note you must submit your final project by the due date in order to receive marks and feedback. You have an optional one week extension after the due date to revise your work (for scholarships / promotion), but this will not receive marks or feedback.</p>
                    <ul class="submitted-files" v-if="data.submissions">
                        <li v-for="submission in data.submissions">
                            <label>Submitted {{submission.createdAt | longDate}}</label>
                            <ul class="files">
                                <li v-for="url in submission.url">
                                    <a :href="url" target="_blank">{{url.split('/').pop()}}</a>
                                </li>
                            </ul>
                            <span v-if="submission.feedback && isLatestGrade(submission.feedback.createdAt)">{{submission.grade}}%</span>
                            <img v-if="submission.feedback" @click="playFeedback(submission.feedback.body)" src="../../../../assets/img/play-button-small-green.png">
                            <!--                             <button v-if="canPostToGallery" @click.prevent="convertToGallery(submission)" class="btn btn-sm btn-success">Add Submission Images to Gallery</button>
 -->
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <h4>Submit Assignment<i class="clippie fa fa-info-circle" v-tooltip="'Drag your file(s) here to submit.'"></i></h4>
                    <dropzone :id="submissionRef" :ref="submissionRef" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="50" v-bind:thumbnail-width="50" v-bind:dropzone-options="dropzoneOptions">
                    </dropzone>
                    <p v-if="dueDateInPast(data.dueDate)" class="submission-explanation">
                        You can submit and resubmit assignments past their due date but don't expect feedback unless you've contacted your supervisor. Late submissions may be subjected to reduced marks.
                    </p>
                    <label>Comments and Questions
                        <i class="clippie fa fa-info-circle" v-tooltip="'Any comments and questions you have about the assignment.'"></i>
                    </label>
                    <textarea v-model="comments" class="comments form-control"></textarea>
                    <button @click.prevent="submit()" v-if="
                (!data.submissions || data.submissions.length < 1)
                && dueDateInFuture(data.dueDate)" class="btn btn-success">Submit</button>
                    <button @click.prevent="submit()" v-if="
                (!data.submissions || data.submissions.length < 1)
                && dueDateInPast(data.dueDate)" class="btn overdue">Submit (Past Due)</button>
                    <button @click.prevent="submit()" v-if="
                (data.submissions && data.submissions.length > 0)
                && dueDateInFuture(data.dueDate)" class="btn resubmit">Resubmit</button>
                    <button @click.prevent="submit()" v-if="
                (data.submissions && data.submissions.length > 0)
                && dueDateInPast(data.dueDate)" class="btn btn-success submitted">Submitted</button>
                    <h4>Submitted Files:<i class="clippie fa fa-info-circle" v-tooltip="'Click submit below to upload your assignment files. Note you can resubmit at anytime to replace them. You may not receive feedback if the due date has passed.'"></i></h4>
                    <ul class="submitted-files" v-if="data.submissions">
                        <li v-for="submission in data.submissions">
                            <a v-for="url in submission.url" :href="url" target="_blank">{{url.split('/').pop()}}</a>
                            <span v-if="submission.feedback && isLatestGrade(submission.feedback.createdAt)">{{submission.grade}}%</span>
                            <img v-if="submission.feedback" @click="playFeedback(submission.feedback.body)" src="../../../../assets/img/play-button-small-green.png">
                            <div class="separator">
                                {{submission.createdAt | shortDate}}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div @click="showLightBox=false" class="lightbox" v-if="showLightBox">
            <i @click="showLightBox=false" class="fa fa-remove"></i>
            <img @click.stop :src="assignmentImage">
        </div>
        <div class="feedback-lightbox" @click="stopFeedback()" v-show="feedbackPlaying===true">
            <i class="fa fa-remove"></i>
            <div class="video-wrapper" @click.stop>
                <poly-video ref="videoPlayer" :vjsOptions="videoPlayerOptions" :sources="videoPlayerSources" @error="onVideoPlayerError" @loadedsource="onVideoPlayerLoadedSource">
                </poly-video>
            </div>
        </div>
    </div>
</template>
<script>
import aws from '../../../../services/aws';
import assignments from '../../../../services/assignments';
import courses from '../../../../services/courses';
import files from '../../../../services/files';

import moment from 'moment';
import toastr from 'toastr';
import Dropzone from 'vue2-dropzone';
import countdown from '../../../reusable/countdown/CountdownTimer.vue';
import DamSubmission from '../../../reusable/dam-submission/DAMSubmission.vue';
import PolyVideo from '../../poly-video';

export default {
    props: ['data'],
    data() {
        return {
            files: null,
            showLightBox: false,
            showDAMSubmission: false,
            submitting: false,
            comments: null,
            files: [],
            dropzoneOptions: {
                autoDiscover: false,
                autoProcessQueue: false,
                maxFilesize: 4000,
                addRemoveLinks: true,

            },
            feedbackLoading: false,
            feedbackPlaying: false,
            videoPlayerSources: [],
            videoPlayerOptions: { fluid: true },
        }
    },
    components: {
        Dropzone,
        countdown,
        DamSubmission,
        PolyVideo
    },
    mounted() {
        //this.getCourse();
        this.$bus.$on('reload_assignment', () => {
            this.showDAMSubmission = false;
        });
    },
    methods: {

        downloadFile(file, assignmentId) {
            file = file.split('?')[0];
            this.$bus.$emit('download', file, 'assignment', assignmentId)
        },

        convertToGallery(submission) {
            this.$store.dispatch('toggle', { type: 'loading', boolean: true });

            this.data.submissions[0].postedToGallery = true;

            assignments.convertToGallery(submission).then((response) => {
                this.$store.dispatch('toggle', { type: 'loading', boolean: false });
                if (response.data.success === true) {
                    toastr.success('Added to gallery');
                    this.$bus.$emit('reload_assignment');
                    this.$router.push('/galleries/' + response.data.gallery.id);

                } else {
                    toastr.error('Error adding to gallery');
                    this.data.submissions[0].postedToGallery = false;
                }
            });
        },

        isLatestGrade(date) {
            let latest = true;
            let created = new Date(date);
            let dates = this.data.submissions.map(function(s) {
                return s.feedback && s.feedback.createdAt;
            }).filter(function(d) { return d; })

            dates.forEach(function(d) {
                if (new Date(d) > created) {
                    latest = false;
                }
            });
            return latest;
        },
        playFeedback(url) {
            if (this.$route.name === 'videoPlayer') {
                const isVideoUrlDiff = () => {
                    if (this.videoPlayerSources.length === 0) {
                        return true;
                    }
                    return this.videoPlayerSources[0] !== url;
                };

                if (isVideoUrlDiff()) {
                    this.feedbackLoading = true;
                    this.$store.dispatch('toggle', {
                        type: 'loading',
                        boolean: true,
                    });
                    this.videoPlayerSources = [url];
                }
                this.feedbackPlaying = true;

            } else {
                this.$bus.$emit('playFeedback', url);
            }
        },
        stopFeedback() {
            this.$refs.videoPlayer.getVjsPlayer().pause();
            this.feedbackPlaying = false;
        },
        onVideoPlayerLoadedSource() {
            if (this.feedbackLoading) {
                this.feedbackLoading = false;
                this.feedbackPlaying = true;
                this.$store.dispatch('toggle', {
                    type: 'loading',
                    boolean: false,
                });
            }
        },
        onVideoPlayerError() {
            if (this.feedbackLoading) {
                this.feedbackLoading = false;
                this.$store.dispatch('toggle', {
                    type: 'loading',
                    boolean: false,
                });
                toastr.error('Error getting feedback video');
            }
        },
        background(url) {
            return 'url("' + url + '")';
        },
        dueDateInFuture(date) {
            return new Date(date) >= new Date();
        },
        dueDateInPast(date) {
            return new Date(date) < new Date();
        },
        getCourse() {
            var self = this;

            self.$store.dispatch('toggle', { type: 'loading', boolean: true });
            courses.get(this, self.data.courseId, null, null).then(function(response) {
                self.$store.dispatch('populate', { type: 'courses', data: [response.data] });
            });
        },

        submit(resubmissionId) {
            var self = this;

            if (self.submitting === true) {
                toastr.error('You are already submitting an assignment');
                return false;
            }


            self.submitting = true;
            self.$store.dispatch('toggle', { type: 'loading', boolean: true });

            self.uploadSubmission().then(function(response) {
                self.sendSubmission(resubmissionId);
            });
        },
        sendSubmission(resubmissionId) {
            var self = this;

            var data = {
                studentId: localStorage.account_id,
                instanceId: self.data.instanceId,
                assignmentId: self.data.id,
                url: self.files
            }

            if (resubmissionId) {
                data.resubmissionId = resubmissionId;
            }
            if (this.comments) {
                data.comments = this.comments;
            }

            let ref = 'assignmentSubmission-' + this.data.id;

            assignments.submit(self, data).then(function(response) {
                response = response.data;
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                if (response.success === true) {
                    toastr.success('Assignment Submitted');
                    self.$refs[ref].dropzone.removeAllFiles();
                    self.comments = null;
                    self.$bus.$emit('reload_assignment');
                    self.$bus.$emit('student_submission');

                } else {
                    toastr.error(response.message);
                }
                self.submitting = false;
                self.files = [];
            });

        },
        uploadSubmission: function() {
            var self = this;
            let ref = 'assignmentSubmission-' + this.data.id;



            if (this.$refs[ref].dropzone.files.length < 1) {
                toastr.error('Please upload your assignment file');
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                return;
            }

            var files = this.$refs[ref].dropzone.files;
           
            let validFileSize = {
                valid: true,
                message: ''
            };

            for (const file of files) {
                if (file.type.includes('image')) {                
                    if (file.size >= 100000000) {
                        validFileSize.valid = false;
                        validFileSize.message += 'Image(s) Exceed 100mb Limit. ';
                    }
                }
                else {
                    if (file.size >= 4000000000) {
                        validFileSize.valid = false;
                        validFileSize.message += 'Media file(s) Exceed 4gb Limit.';
                    }
                }
            }

            if (validFileSize.valid !== true) {
                toastr.error(validFileSize.message);
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                return false;
            }
            var promises = [];

            files.forEach(function(file) {
                // AWS doesn't like these
                const filename = file.name.replace(/ /g, '_').replace(/&|\$|@|=|;|:|\%|\+|,|\?/g, '').replace(/\.[^/.]+$/, "") + '_' + new Date().getMilliseconds() + parseInt(Math.random() * 100) + '.' + file.name.split('.').pop();

                let promise = new Promise(function(resolve, reject) {
                    aws.signature(file, filename, 'ttto-assignment-submissions').then(function(signature) {
                        aws.getPresignedUrl(self, 'ttto-assignment-submissions', filename, 'putObject', false).then(function(presignedUrl) {
                            const acceleratedUrl = presignedUrl.data.replace('s3.us-west-2','s3-accelerate');

                            aws.upload(file, filename, signature, 'ttto-assignment-submissions', acceleratedUrl).then(function(response) {

                                if (!self.files.includes(response.url)) self.files.push(response.url);

                                resolve(true)

                            }).catch(function(error) {
                                console.log(error);
                                self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                                resolve(false)
                            });
                        });
                    });
                });

                promises.push(promise);

            });

            return new Promise(function(resolve, reject) {
                Promise.all(promises).then(function(res) {
                    resolve(true)
                });
            });

        },
    },
    computed: {
        canPostToGallery() {
            return !this.data.submissions.find(s => s.postedToGallery === true);
        },

        submissionRef() {
            return 'assignmentSubmission-' + this.data.id
        },
        assignmentImage() {
            var self = this;
            if (self.data.image) return self.data.image;
            if (this.$store.getters.courses && this.$store.getters.courses.length > 0) {

                if (this.$route.name === 'videoPlayer') {
                    return this.$store.getters.courses[0].image;
                } else {
                    return this.$store.getters.courses.filter(function(c) {
                        return ((c.associated.courseId == self.data.courseId) || (c.associated.instanceId == self.data.instanceId))
                    })[0].associated.image

                }
            }
        }
    }
}

</script>
<style lang="scss">
.table-hover>tbody>tr {
    background-color: #363636 !important;
}

.table-hover>tbody>tr:hover {
    background-color: #363636 !important;
}

tr.VueTables__child-row td {
    background: #222222;
    //padding-bottom: 35px!important;
}

.dz-error-mark,
.dx-filename {
    display: none !important;
}

</style>
<style lang="scss" scoped>
.final-assignment-submission {
    .submitted-files>li {
        background: lighten(#222, 5%);
        padding: 1rem;
        margin-bottom: 2rem;
    }

}

textarea.comments {
    margin-bottom: 3rem;
}

.btn.resubmit {
    background: #16576D;
    color: #fff;
}

.btn.overdue {
    background: #C33A44;
    color: #fff;
}

.btn.submitted {
    background: #3AC384;
    color: #444;
}

.assignment-sidebar {
    border-left: 1px solid #666;
    padding-top: 20px;
    padding-bottom: 30px;

    .vue-dropzone {
        margin-top: 2rem;
    }

    .student-submitted-files {
        margin-bottom: 2rem;


        li {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        a {
            cursor: pointer;
        }
    }

    .due-date {
        margin: 0;
    }

    .countdown {
        //font-weight: 700;
    }

    button {
        margin-bottom: 1rem;
    }
}

.assignment-image {
    margin-top: 45px;
    box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, .3);
}



.course-description {
    padding-top: 2rem;

    p {
        margin-top: 1rem;
        white-space: pre-wrap;
    }
}

.wrapper {
    display: flex;
}

.submitted-files {
    margin-bottom: 2rem;

    .separator {
        font-size: 12px;
        text-align: right;
        font-weight: 100;
        border-bottom: 1px solid #666;
        margin-top: -1rem;
        color: #ccc;
    }

    li {
        margin-bottom: 1rem;
        clear: both;
    }

    a {
        word-break: break-all;
        display: block;
        margin-bottom: 10px;
    }

    img {
        width: 20px;
        height: auto;
        cursor: pointer;
    }
}

.background {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.15;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    object-fit: cover;
}

.submission-explanation {
    font-size: 13px;
    margin-top: 15px;
    color: #ccc;
}

</style>



// WEBPACK FOOTER //
// Child.vue?7870f339